import { useSsrAdapter as C } from "./highrise721.mjs";
import { inject as H, ref as O, watchEffect as S } from "vue";
import { c as N } from "./highrise314.mjs";
import { configProviderInjectionKey as P } from "./highrise1066.mjs";
import { throwError as R } from "./highrise1064.mjs";
import h from "./highrise1184.mjs";
function E(v, s, n, p) {
  n || R("useThemeClass", "cssVarsRef is not passed");
  const t = H(P, null), r = t == null ? void 0 : t.mergedThemeHashRef, g = t == null ? void 0 : t.styleMountTarget, i = O(""), y = C();
  let o;
  const T = `__${v}`, $ = () => {
    let e = T;
    const l = s ? s.value : void 0, m = r == null ? void 0 : r.value;
    m && (e += `-${m}`), l && (e += `-${l}`);
    const {
      themeOverrides: a,
      builtinThemeOverrides: f
    } = p;
    a && (e += `-${h(JSON.stringify(a))}`), f && (e += `-${h(JSON.stringify(f))}`), i.value = e, o = () => {
      const d = n.value;
      let u = "";
      for (const c in d)
        u += `${c}: ${d[c]};`;
      N(`.${e}`, u).mount({
        id: e,
        ssr: y,
        parent: g
      }), o = void 0;
    };
  };
  return S(() => {
    $();
  }), {
    themeClass: i,
    onRender: () => {
      o == null || o();
    }
  };
}
export {
  E as useThemeClass
};
